import $ from 'jquery';

jQuery(document).ready(function($) {
    $(document).on('click', '.seo-audit-tab-btn', function(e) {
        e.preventDefault();
        var $btn = $(this);
        var target = $btn.data('tab-target');
        var $item = $btn.closest('.seo-audit-tab-item');

        $('.seo-audit-tab-btn').removeClass('active');
        $('.seo-audit-tab-item').removeClass('active');
        $('.seo-audit-tab-pane').removeClass('active');

        $btn.addClass('active');
        if ($item.length) {
            $item.addClass('active');
        }
        $(target).addClass('active');

        // Scroll to tab top after layout update so user doesn't have to scroll up manually
        setTimeout(function() {
            var header = document.querySelector('.site-header');
            var headerHeight = header ? (header.getBoundingClientRect().height || header.offsetHeight || 0) : 80;
            var adminBar = document.getElementById('wpadminbar');
            var adminBarHeight = adminBar ? (adminBar.getBoundingClientRect().height || adminBar.offsetHeight || 0) : 0;
            var offset = headerHeight + adminBarHeight + 20;

            if (window.innerWidth <= 1025) {
                var targetEl = $item.length ? $item[0] : $btn[0];
                if (targetEl) {
                    var rect = targetEl.getBoundingClientRect();
                    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    var targetY = rect.top + scrollTop - offset;

                    window.scrollTo({
                        top: Math.max(0, targetY),
                        behavior: 'smooth'
                    });
                }
            } else {
                // Desktop: if user has scrolled past top of the tabs section, scroll to top of section
                var $wrapper = $btn.closest('.seo-audit-tabs-wrapper-responsive');
                if ($wrapper.length) {
                    var secRect = $wrapper[0].getBoundingClientRect();
                    if (secRect.top < offset) {
                        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        var targetY = secRect.top + scrollTop - offset;
                        window.scrollTo({
                            top: Math.max(0, targetY),
                            behavior: 'smooth'
                        });
                    }
                }
            }
        }, 50);
    });
});
